export default {
  buttons: { done: 'Færdig' },
  title: 'Placering',
};
